'use client';

import { clientFetch } from '@/lib/api/clientFetch';
import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import './newsletter.scss';

function isValidEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

export default function Newsletter({ messages = {} }) {
  const [newsEmail, setNewsEmail] = useState('');
  const [isPending, setIsPending] = useState(false);
  const [feedback, setFeedback] = useState({ tone: '', message: '' });

  const title = messages.title || 'Newsletter';
  const text =
    messages.text || 'Subscribe to get the latest updates and offers.';
  const formTitle = messages.formTitle || 'newsletter form';
  const placeholder =
    messages?.form?.newsEmail?.placeholder || 'Enter email...';
  const subscribeLabel = messages?.button?.submit || 'Subscribe';

  const submitHandler = async (event) => {
    event.preventDefault();

    const normalizedEmail = newsEmail.trim().toLowerCase();

    if (!isValidEmail(normalizedEmail)) {
      setFeedback({ tone: 'error', message: 'Enter a valid email address.' });
      return;
    }

    setIsPending(true);
    setFeedback({ tone: '', message: '' });

    try {
      await clientFetch('/api/users/newsletter', {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({ newsEmail: normalizedEmail }),
      });

      setNewsEmail('');
      setFeedback({
        tone: 'success',
        message: 'Subscription saved. You will receive future updates here.',
      });
    } catch (error) {
      setFeedback({
        tone: 'error',
        message:
          error?.data?.message ||
          'Could not subscribe right now. Please try again.',
      });
    } finally {
      setIsPending(false);
    }
  };

  return (
    <div className="newsletter-panel">
      <h5 className="footer-heading mb-1 mb-sm-3">{title}</h5>
      <p className="mb-2">{text}</p>
      <Form title={formTitle} onSubmit={submitHandler}>
        <Form.Group>
          <Form.Control
            type="email"
            id="newsLetterEmail"
            name="newsLetterEmail"
            placeholder={placeholder}
            spellCheck="false"
            autoComplete="email"
            value={newsEmail}
            onChange={(event) => setNewsEmail(event.target.value)}
            className="mb-2 text-center rounded-0"
            disabled={isPending}

          />
          <Button
            type="submit"
            variant="info"
            disabled={isPending}
            className="newsletter-submit"
          >
            {isPending ? 'Saving...' : subscribeLabel}
          </Button>
        </Form.Group>
      </Form>

      {feedback.message ? (
        <p
          className={`newsletter-feedback mt-2 mb-0 is-${feedback.tone}`.trim()}
          role="status"
          aria-live="polite"
        >
          {feedback.message}
        </p>
      ) : null}
    </div>
  );
}
